import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { Channels } from '@eureka/shared/login-sdk';
import {
    getUsageAmountWhereFromLocation,
    isHomeAgentUsageAmountWhere,
} from '@/utils/agentic-search/agent-type';

export interface LoginDialogService {
    open(): Promise<void>
}

@injectable()
export class LoginDialogServiceImpl implements LoginDialogService {
    open() {
        return import('@eureka/shared/login-sdk').then(({ loginSDK }) => {
            const usageAmountWhere = getUsageAmountWhereFromLocation();
            const channels: Channels = isHomeAgentUsageAmountWhere(usageAmountWhere)
                ? {
                    from_page: usageAmountWhere,
                    channel_source: usageAmountWhere,
                }
                : {
                    from_page: 'agent_rd_home',
                    channel_source: 'agent_rd_home',
                };
            loginSDK.setChannels(channels);
            return loginSDK.open({
                withoutClose: true,
            }).then(() => {
                window.location.reload();
            });
        });
    }
}

export const LoginDialogService = Symbol('LoginDialogService');
